import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-alert',
    templateUrl: './under-construction.component.html',
    styleUrls: ['./under-construction.component.scss'],
    standalone: false
})
export class UnderConstructionComponent implements OnInit {

    constructor() { }

    ngOnInit() { }

    closeDiv() {
    }

}
